// Central contact config.
export const CONTACT = {
  email: "info@viralvisionmediaau.com",
};
